import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import PainPointIdentification from "./sections/PainPointIdentification";
import TheFutureOfOurState from "./sections/TheFutureOfOurState";
import TheAirobotMission from "./sections/TheAirobotMission";
import HowItWorks from "./sections/HowItWorks";
import OurCoreCompetencies from "./sections/OurCoreCompetencies";
import VoicesOfSatisfaction from "./sections/VoicesOfSatisfaction";
import ScaleYourContent from "./sections/ScaleYourContent";
import PainPointQualifier from "./sections/PainPointQualifier";
import PieDePaginaArtek from "@/reusable_sections/Footer";
import FloatingWhatsAppCTA from "./sections/FloatingWhatsAppCTA";
export default function HomePage() {
  return <div>
      <Header />
      <PainPointIdentification />
      <TheFutureOfOurState />
      <PainPointQualifier />
      <OurCoreCompetencies />
      <HowItWorks />
      <VoicesOfSatisfaction />
      <TheAirobotMission />
      <ScaleYourContent />
      <PieDePaginaArtek />
      <FloatingWhatsAppCTA />
    </div>;
}